<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="toc" id="toc">
<h1 class="toc">CONTENTS</h1>
<p class="nonindent" id="cvi"><a class="hlink" href="#/OEBPS/9780062031716_epub_cvi_r1.htm">Cover</a></p>
<p class="nonindent" id="tp"><a class="hlink" href="#/OEBPS/9780062031716_epub_tp_r1.htm">Title Page</a></p>
<p class="nonindent" id="ded"><a class="hlink" href="#/OEBPS/9780062031716_epub_ded_r1.htm">Dedication</a></p>
<p class="nonindent" id="int"><a class="hlink" href="#/OEBPS/9780062031716_epub_int_r1.htm">INTRODUCTION</a></p>
<p class="nonindent" id="c01"><a class="hlink" href="#/OEBPS/9780062031716_epub_c01_r1.htm">GETTING STARTED: IN THE MOOD FOR LOVE</a></p>
<p class="nonindent" id="c02"><a class="hlink" href="#/OEBPS/9780062031716_epub_c02_r1.htm">PLAYING THE DATING GAME</a></p>
<p class="nonindent" id="c03"><a class="hlink" href="#/OEBPS/9780062031716_epub_c03_r1.htm">HEALTH WARNING</a></p>
<p class="nonindent" id="c04"><a class="hlink" href="#/OEBPS/9780062031716_epub_c04_r1.htm">HOPELESSLY DEVOTED</a></p>
<p class="nonindent" id="c05"><a class="hlink" href="#/OEBPS/9780062031716_epub_c05_r1.htm">FINDING THE WORDS/THE ONE THAT GOT AWAY</a></p>
<p class="nonindent" id="c06"><a class="hlink" href="#/OEBPS/9780062031716_epub_c06_r1.htm">WILD NIGHTS</a></p>
<p class="nonindent" id="c07"><a class="hlink" href="#/OEBPS/9780062031716_epub_c07_r1.htm">THE MORNING AFTER</a></p>
<p class="nonindent" id="c08"><a class="hlink" href="#/OEBPS/9780062031716_epub_c08_r1.htm">TECHNICAL DIFFICULTIES</a></p>
<p class="nonindent" id="c09"><a class="hlink" href="#/OEBPS/9780062031716_epub_c09_r1.htm">PASSING FANCIES</a></p>
<p class="nonindent" id="c10"><a class="hlink" href="#/OEBPS/9780062031716_epub_c10_r1.htm">THE SOUL MATE</a></p>
<p class="nonindent" id="c11"><a class="hlink" href="#/OEBPS/9780062031716_epub_c11_r1.htm">WHEN THE KISSING HAS TO STOP</a></p>
<p class="nonindent" id="c12"><a class="hlink" href="#/OEBPS/9780062031716_epub_c12_r1.htm">HOW CAN I BE SURE?</a></p>
<p class="nonindent" id="c13"><a class="hlink" href="#/OEBPS/9780062031716_epub_c13_r1.htm">WONDER WEDLOCK</a></p>
<p class="nonindent" id="c14"><a class="hlink" href="#/OEBPS/9780062031716_epub_c14_r1.htm">HAPPY TOGETHER</a></p>
<p class="nonindent" id="c15"><a class="hlink" href="#/OEBPS/9780062031716_epub_c15_r1.htm">MARRIAGE BLOWS</a></p>
<p class="nonindent" id="c16"><a class="hlink" href="#/OEBPS/9780062031716_epub_c16_r1.htm">TWO SCHOOLS OF THOUGHT</a></p>
<p class="nonindent" id="c17"><a class="hlink" href="#/OEBPS/9780062031716_epub_c17_r1.htm">PARENTHOOD</a></p>
<p class="nonindent" id="c18"><a class="hlink" href="#/OEBPS/9780062031716_epub_c18_r1.htm">THE GRASS IS GREENER</a></p>
<p class="nonindent" id="c19"><a class="hlink" href="#/OEBPS/9780062031716_epub_c19_r1.htm">MARRIAGES CAN GO UP AS WELL AS DOWN</a></p>
<p class="nonindent" id="c20"><a class="hlink" href="#/OEBPS/9780062031716_epub_c20_r1.htm">END GAME</a></p>
<p class="nonindent" id="c21"><a class="hlink" href="#/OEBPS/9780062031716_epub_c21_r1.htm">THE SHORT GOOD-BYE</a></p>
<p class="nonindent" id="c22"><a class="hlink" href="#/OEBPS/9780062031716_epub_c22_r1.htm">EMPTY BEDS</a></p>
<p class="nonindent" id="c23"><a class="hlink" href="#/OEBPS/9780062031716_epub_c23_r1.htm">GETTING OVER IT</a></p>
<p class="nonindent" id="c24"><a class="hlink" href="#/OEBPS/9780062031716_epub_c24_r1.htm">THIS YEAR’S MODEL</a></p>
<p class="nonindent" id="c25"><a class="hlink" href="#/OEBPS/9780062031716_epub_c25_r1.htm">FOR OLD TIMES’ SAKE</a></p>
<p class="nonindent" id="c26"><a class="hlink" href="#/OEBPS/9780062031716_epub_c26_r1.htm">LOST FOREVER</a></p>
<p class="nonindent" id="c27"><a class="hlink" href="#/OEBPS/9780062031716_epub_c27_r1.htm">YOU CAN RUN …</a></p>
<p class="nonindent" id="c28"><a class="hlink" href="#/OEBPS/9780062031716_epub_c28_r1.htm">SENIOR MOMENTS</a></p>
<p class="nonindent" id="c29"><a class="hlink" href="#/OEBPS/9780062031716_epub_c29_r1.htm">THE LAST DETAIL</a></p>
<p class="nonindent" id="bm1"><a class="hlink" href="#/OEBPS/9780062031716_epub_bm1_r1.htm">AUTHOR BIOGRAPHIES</a></p>
<p class="nonindent" id="ind"><a class="hlink" href="#/OEBPS/9780062031716_epub_ind_r1.htm">INDEX</a></p>
<p class="nonindent" id="ata"><a class="hlink" href="#/OEBPS/9780062031716_epub_ata_r1.htm">About the Author</a></p>
<p class="nonindent" id="atb"><a class="hlink" href="#/OEBPS/9780062031716_epub_atb_r1.htm">About the Book</a></p>
<p class="nonindent" id="bm2"><a class="hlink" href="#/OEBPS/9780062031716_epub_bm2_r1.htm">Credits</a></p>
<p class="nonindent" id="cop"><a class="hlink" href="#/OEBPS/9780062031716_epub_cop_r1.htm">Copyright</a></p>
<p class="nonindent" id="pub"><a class="hlink" href="#/OEBPS/About_the_Publisher.htm">About the Publisher</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062031716_epub_toc_r1.vue?4cab225f